// extracted by mini-css-extract-plugin
module.exports = {"promoContainer":"promo-module--promo-container--2wlJ8"};